import React from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import { Apify } from '../Apify';
import { connect } from 'react-redux';
import { T } from '../traks';
import { canViewGroupReports, canViewUserReports } from '../GameConfig';

var UserReports = (props) => {
    var rows = [];

    if (props.reports) {
        for (const row of props.reports) {
            rows.push(
                <tr key={`${row.Week}-${row.Year}`} className="ad_game_table_border ad_grey_hover">
                    <td className="fw-bold">{row.Name}</td>
                    <td className="fw-bold">{row.Week}</td>
                    <td className="fw-bold">{row.Year}</td>
                    <td className="fw-bold"><a className="fw-bold txt-color-green" href={row.Link}><T>Download</T></a></td>
                </tr>
            );
        }
    }

    return (
        <Container className='mt-4'>
            <Row className='ad_game_box flex-column'>
                <Row xs="12" className="py-4 px-3">
                    <Col xs="12">
                        <h3><T>User Reports</T></h3>
                    </Col>
                    <Col xs="12">
                        <T>Download weekly CSV files containing user statistics.</T>
                        <p><T>Each report is generated automatically about one hour after the US stock market closes on Friday.</T></p>
                    </Col>
                </Row>      
                {rows.length === 0 ? (
                    <Row className="pb-4">
                        <Col className="pb-5" md="12">
                            <div className="ad_notification_box py-2 px-4">
                                <div className="ad_notification_header"><T>No reports available yet.</T></div>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="ad_notification_box ad_game_box pt-3">
                        <Col xs="12" className="overflow-auto">
                            <div className="ad_trade_history_table_wrapper">
                                <Table className="bg-color-white">
                                    <thead>
                                        <tr>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>File</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Week</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Year</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Download</T></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                )}
                <div className="p-4"/>
            </Row>
        </Container>
    )
}

var GroupGrowthReports = (props) => {
    var rows = [];

    if (props.reports) {
        for (const row of props.reports) {
            rows.push(
                <tr key={`${row.Week}-${row.Year}`} className="ad_game_table_border ad_grey_hover">
                    <td className="fw-bold">{row.Name}</td>
                    <td className="fw-bold">{row.Week}</td>
                    <td className="fw-bold">{row.Year}</td>
                    <td className="fw-bold"><a className="fw-bold txt-color-green" href={row.Link}><T>Download</T></a></td>
                </tr>
            );
        }
    }

    return (
        <Container className='mt-4 mb-4'>
            <Row className='ad_game_box flex-column'>
                <Row xs="12" className="py-4 px-3">
                    <Col xs="12">
                        <h3><T>Top 3 Portfolio Growth Reports</T></h3>
                    </Col>
                    <Col xs="12">
                        <T>Download weekly CSV reports showing the top 3 portfolios with the highest growth.</T>
                        <p><T>Reports are generated automatically based on the difference between last week's and this week's portfolio snapshots and are available around 03:00 on Saturday.</T></p>
                    </Col>
                </Row>
                <Row></Row>       
                {rows.length === 0 ? (
                    <Row className="pb-1">
                        <Col className="pb-5" md="12">
                            <div className="ad_notification_box py-2 px-4">
                                <div className="ad_notification_header"><T>No reports available yet.</T></div>
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="ad_notification_box ad_game_box pt-3">
                        <Col xs="12" className="overflow-auto">
                            <div className="ad_trade_history_table_wrapper">
                                <Table className="bg-color-white">
                                    <thead>
                                        <tr>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>File</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Week</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Year</T></th>
                                            <th className="ad_game_table_header font-s pl-3 text-uppercase text-nowrap"><T>Download</T></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                )}
                <div className="p-4"/>
            </Row>
        </Container>
    )
}

UserReports = Apify("/a/user_reports")
	.with_response_prop("reports")
	.wrap(UserReports);


GroupGrowthReports = Apify("/a/user_group_reports")
    .with_response_prop("reports")
	.wrap(GroupGrowthReports);

var UserReportsHandler = (props) => {
    const me = props.me;

    let userReports, userGroupReports = null;
    if (canViewUserReports(me)) {
        userReports = <UserReports me={me} />
    }

    if (canViewGroupReports(me)) {
        userGroupReports = <GroupGrowthReports me={me} />
    }

    return (
        [userReports, userGroupReports]
    )
}

export default connect(
	(state) => ({me: state.me})
)((props) => props.me && <UserReportsHandler me={props.me}/>);


// WEBPACK FOOTER //
// ./src/p/UserReports.js